import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {NzMessageService} from 'ng-zorro-antd';
import {InteractionsService, RootService} from '../../services';
import {debounceTime, takeUntil} from 'rxjs/operators';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import * as moment from 'moment';

interface ItemData {
  id: number;
  name: string;
  age: number;
  address: string;
}

@Component({
  selector: 'app-interactions',
  templateUrl: './interactions.component.html',
  styleUrls: ['./interactions.component.scss']
})
export class InteractionsComponent implements OnInit, OnDestroy {

  pageIndex = 1;
  pageSize = 10;
  changeAction;
  isAllDisplayDataChecked = false;
  isIndeterminate = false;
  listOfDisplayData: ItemData[] = [];
  listOfAllData: ItemData[] = [];
  mapOfCheckedId: { [key: string]: boolean } = {};
  loading = false;
  total: number;
  // tslint:disable-next-line:variable-name
  actions = [
    {label: 'Thêm mới', value: 0},
    {label: 'Export', value: 1},
    {label: 'Bỏ chặn', value: 2},
    {label: 'Xóa', value: 3},
  ];
  // statusPhone = false;

  // @ts-ignore
  dateRange = [new Date(moment(new Date()).add(-1, 'month')), new Date()];
  unsubscribe$ = new Subject<void>();
  ids: any[] = [];
  imageFalse = [];
  query;
  name;
  // tslint:disable-next-line:variable-name
  province_id;
  // tslint:disable-next-line:variable-name
  action_type;
  city: any;
  isLoading = false;
  searchChange$ = new BehaviorSubject('');
  optionList: any;
  outOfNext =  true;
  // @ts-ignore
  @ViewChild('contactGroup') contactGroup;

  constructor(
    private router: Router,
    // private store: Store<fromInformationCtv.CtvState>,
    // private informationCtvService: InformationCtvService,
    private message: NzMessageService,
    private interactionsService: InteractionsService,
    private notification: NzNotificationService,
    private rootService: RootService,
  ) {
    const optionList$: Observable<string> = this.searchChange$
      .asObservable()
      .pipe(debounceTime(500));

    optionList$.pipe(takeUntil(this.unsubscribe$)).subscribe(value => {

      if (value && value.trim().length > 0) {
        const query = {
          key: value.trim()
        };
        this.interactionsService.searchProduct(query).pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
          this.optionList = res.items;
          this.isLoading = false;
        });
      } else {
        this.optionList = [];
        this.isLoading = false;

      }

    });
  }

  ngOnInit(): void {

    // const today = new Date();
    // // @ts-ignore
    // const startDate = new Date(moment(new Date()).add(-1, 'month'));
    // this.dateRange = [startDate, today];
    // console.log(this.dateRange);

    this.notification.config({
      nzPlacement: 'bottomRight'
    });
    this.rootService.listCities().pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
      this.city = res.data.items;
    });
    this.loadData();
  }

  async loadData(ms = 0) {
    this.loading = true;
    this.query = {
      product_id: this.name ? this.name.trim() : '',
      action_type: this.action_type ? this.action_type : '',
      begin_at: this.dateRange && this.dateRange.length > 0 ? this.formatDate(this.dateRange[0]) : '',
      end_at: this.dateRange && this.dateRange.length > 0 ? this.formatDate(this.dateRange[1]) : '',
      province_id: this.province_id ? this.province_id : '',
      page: this.pageIndex,
      page_size: this.pageSize
    };
    await this.sleep(ms);
    this.interactionsService.list(this.query).pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
        this.loading = false;
        this.total = res.totalElement;
        this.listOfAllData = res.items;


        if (res.items.length === 0 && this.pageIndex > 1) {
          this.pageIndex = this.pageIndex - 1;
          this.outOfNext = false;
          this.loadData();
        }
      },
      error => {
        this.loading = false;
        this.notification.create(
          'error',
          'Thất bại',
          'Lấy danh sách nhà phân phối thất bại'
        );
      });

  }

  next() {
    this.pageIndex += 1;
    this.loadData();
  }

  pev() {
    if (this.pageIndex > 1) {
      this.pageIndex -= 1;
      this.outOfNext = true;
      this.loadData();

    }

  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }


  // hideModal(): void {
  //   this.contactGroup.handleCancel();
  //
  // }

  showStatusPhone() {
    this.contactGroup.showModal();

  }

  search() {
    console.log(this.dateRange);
    this.pageIndex = 1;
    this.outOfNext = true;

    this.loadData();
  }

  reset() {
    this.pageIndex = 1;
    this.outOfNext = true;
    this.name = undefined;
    this.action_type = undefined;
    // @ts-ignore
    this.dateRange = [new Date(moment(new Date()).add(-1, 'month')), new Date()];
    this.province_id = undefined;
    this.loadData();
  }


  currentPageDataChange($event: ItemData[]): void {
    this.listOfDisplayData = $event;
    this.refreshStatus();
  }

  refreshStatus(): void {
    if (this.listOfDisplayData.length > 0) {
      this.isAllDisplayDataChecked = this.listOfDisplayData.every(item => this.mapOfCheckedId[item.id]);
    } else {
      this.isAllDisplayDataChecked = false;
    }
    this.isIndeterminate =
      this.listOfDisplayData.some(item => this.mapOfCheckedId[item.id]) && !this.isAllDisplayDataChecked;
    this.ids = [];
    for (const [key, value] of Object.entries(this.mapOfCheckedId)) {
      // tslint:disable-next-line:triple-equals
      if (value == true) {
        this.ids.push(key);
      }
    }

  }

  checkAll(value: boolean): void {
    this.listOfDisplayData.forEach(item => (this.mapOfCheckedId[item.id] = value));
    this.refreshStatus();
  }


  actionsButton() {
    if (this.changeAction === '3') {
      this.exportExcel();
    }
  }

  /*Check link image error*/
  checkImageErr(imageError) {
    this.imageFalse.push(imageError);
  }

  showImage(id: any, imageLink) {
    if (!this.imageFalse.includes(id)) {
      // @ts-ignore
      window.open(imageLink, '_blank');
    }
  }

  /*End Check link image error*/

  formatDate(timestamp) {
    const now = new Date(timestamp);
    const year = '' + now.getFullYear();
    let month = '' + (now.getMonth() + 1);
    if (month.length === 1) {
      month = '0' + month;
    }
    let day = '' + now.getDate();
    if (day.length === 1) {
      day = '0' + day;
    }
    return day + '-' + month + '-' + year;
  }

  exportExcel() {
    const query = {
      export_all: this.ids.length === 0,
      ids: this.ids.length !== 0 ? this.ids.toString() : '',
      product_id: this.name ? this.name.trim() : '',
      action_type: this.action_type ? this.action_type : '',
      begin_at: this.dateRange.length > 0 ? this.formatDate(this.dateRange[0]) : '',
      end_at: this.dateRange.length > 0 ? this.formatDate(this.dateRange[1]) : '',
      province_id: this.province_id ? this.province_id : '',
      page: this.pageIndex,
      pageSize: this.total
    };
    this.interactionsService.exportExcel(query).pipe(takeUntil(this.unsubscribe$)).subscribe((data) => {
      this.rootService.export(data, 'Lịch sử tương tác.xlsx');
    });
  }


  onSearch(value: string): void {
    this.isLoading = true;
    this.searchChange$.next(value);

  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
